export default __webpack_public_path__ + "static/media/numberwrap.9d332ff3.png";